var _rect, _g, _defs;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPaymentLink(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 40,
    height: 41,
    viewBox: "0 0 40 41",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 0.500092,
    width: 40,
    height: 40,
    rx: 15,
    fill: "#F8B400",
    fillOpacity: 0.15
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_8318_5433)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M25.033 15.4661C25.617 16.0491 25.617 16.9951 25.033 17.5781L17.078 25.5341C16.495 26.1171 15.549 26.1171 14.966 25.5341C14.383 24.9511 14.383 24.0051 14.966 23.4221L22.922 15.4661C23.504 14.8831 24.45 14.8831 25.033 15.4661ZM15.895 28.8521C14.724 30.0231 12.819 30.0231 11.647 28.8521C10.476 27.6811 10.476 25.7751 11.647 24.6041L17.286 18.9721C15.394 18.5131 13.315 19.0221 11.837 20.5001L9.69001 22.6471C7.43601 24.9011 7.43601 28.5561 9.69001 30.8101C11.944 33.0641 15.599 33.0641 17.853 30.8101L20 28.6621C21.477 27.1851 21.986 25.1061 21.527 23.2141L15.895 28.8521ZM22.146 10.1901L20 12.3381C18.522 13.8161 18.01 15.8911 18.47 17.7831L24.104 12.1481C25.276 10.9771 27.181 10.9771 28.352 12.1481C29.524 13.3191 29.524 15.2251 28.352 16.3961L22.717 22.0311C24.61 22.4901 26.685 21.9781 28.162 20.5011L30.308 18.3541C32.562 16.1001 32.562 12.4461 30.308 10.1911C28.055 7.9371 24.4 7.9371 22.146 10.1901Z",
    fill: "#028789"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_8318_5433"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white",
    transform: "translate(8 8.50009)"
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentLink);
export default __webpack_public_path__ + "static/media/payment_link.d130a19a407888e8aa863a70720898c9.svg";
export { ForwardRef as ReactComponent };